

























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { vxm } from '@/store';

@Component
export default class FootprintListModal extends Vue {
  @Prop({ type: Number, default: 0 })
  private accountTotalFootprints!: number;
  @Prop({ type: Boolean, default: false })
  private loading!: boolean;
  @Prop({ type: Boolean, default: true })
  private footprintsLoading!: boolean;
  public isOpenProfileFootprintCard: boolean = false;
  private listClass = { footprintList: 'footprint-list' };

  private openProfileFootprintCard() {
    this.isOpenProfileFootprintCard = true;
    this.onclick();
  }

  private closeProfileFootprintCard() {
    this.isOpenProfileFootprintCard = false;
  }

  // 足跡を付けた日時から現在までの経過時間を求めるメソッド
  private getElapsedTime(visitTime: Date): string {
    const difference = new Date().getTime() - new Date(visitTime).getTime();
    const elapsed = new Date(difference);
    if (elapsed.getUTCFullYear() - 1970) {
      return `${elapsed.getUTCFullYear() - 1970}年前`;
    } else if (elapsed.getUTCMonth()) {
      return `${elapsed.getUTCMonth()}ヶ月前`;
    } else if (elapsed.getUTCDate() - 1) {
      return `${elapsed.getUTCDate() - 1}日前`;
    } else if (elapsed.getUTCHours()) {
      return `${elapsed.getUTCHours()}時間前`;
    } else if (elapsed.getUTCMinutes()) {
      return `${elapsed.getUTCMinutes()}分前`;
    } else {
      return `${elapsed.getUTCSeconds()}たった今`;
    }
  }

  //TODO: 正確なパスを含めないと表示エラーとなるため、デフォルト画像などが決定するまで仮置でパスを指定
  private getImageSrc(imagePath: string | null) {
    imagePath = 'worker4.jpg';
    return require(`@/assets/${imagePath}`);
  }

  private onclick() {
    let count = 0;
    const getList = () => {
      if (++count > 20) return;
      const elements = document.getElementsByClassName(this.listClass.footprintList);
      if (elements.length) {
        const menu = elements[0];
        menu.addEventListener('scroll', () => {
          if (menu.scrollHeight - (menu.clientHeight + menu.scrollTop) < 5) {
            if (!this.loadCompleted && !this.loading) {
              const pagination = this.accountFootprints?.pagination;
              if (!pagination) {
                return;
              }
              this.scrollend(pagination.lastAccountFootprintId, pagination.lastCreatedAt);
            }
          }
        });
      } else {
        setTimeout(() => getList(), 100);
      }
    };
    getList();
  }

  /**全ての足跡を取得している場合はtrueを返す */
  private get loadCompleted() {
    if (this.accountFootprints) {
      return this.accountFootprints.results.length >= this.accountTotalFootprints;
    }
  }

  private get accountFootprints() {
    return vxm.theoryApi.accountsStore.getAccountFootprints;
  }

  @Emit('next')
  private scrollend(lastId: number | null, lastCreatedAt: Date | null) {
    return {
      lastId: lastId,
      lastCreatedAt: lastCreatedAt,
    };
  }
}
